import React from "react";

import { SiteLayout } from "./src/layout/SiteLayout";

export const wrapPageElement = ({ element, props }: any) => <SiteLayout {...props}>{element}</SiteLayout>;
